// 这里放置一些Vue自定义Filter
export const formatDate = time => {
  if (time === null || time === '') {
    return ''
  }
  if (time) {
    let tmpDate = new Date(time)
    let year = tmpDate.getFullYear()
    let mathon = tmpDate.getMonth() + 1
    if (mathon < 10) {
      mathon = '0' + mathon
    }
    let day = tmpDate.getDate()
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + mathon + '-' + day
  } else {
    return ''
  }
}

export const formatTime = time => {
  if (time === null || time === '') {
    return ''
  }
  let tmpDate = new Date(time)
  let year = tmpDate.getFullYear()
  let mathon = tmpDate.getMonth() + 1
  if (mathon < 10) {
    mathon = '0' + mathon
  }
  let day = tmpDate.getDate()
  if (day < 10) {
    day = '0' + day
  }
  let hours = tmpDate.getHours()
  if (hours < 10) {
    hours = '0' + hours
  }
  let minutes = tmpDate.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  return year + '-' + mathon + '-' + day + ' ' + hours + ':' + minutes
}

export const formatDateByChinese = time => {
  if (time === null || time === '') {
    return ''
  }
  let tmpDate = new Date(time)
  let year = tmpDate.getFullYear()
  let mathon = tmpDate.getMonth() + 1
  if (mathon < 10) {
    mathon = '0' + mathon
  }
  let day = tmpDate.getDate()
  if (day < 10) {
    day = '0' + day
  }
  return year + '年' + mathon + '月' + day + '日'
}

export const getYear = time => {
  if (time === null || time === '') {
    return ''
  }
  let tmpDate = new Date(time)
  let year = tmpDate.getFullYear()
  return year
}

export const getMonth = time => {
  if (time === null || time === '') {
    return ''
  }
  let tmpDate = new Date(time)
  let month = tmpDate.getMonth() + 1
  return month
}

export const getDay = time => {
  if (time === null || time === '') {
    return ''
  }
  let tmpDate = new Date(time)
  let day = tmpDate.getDate()
  return day
}

// 生成组件的唯一id
export const GUID = () =>
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  )
